module.exports = __webpack_public_path__ + "img/accounting-personal-services-tax.d2882eab.svg";